export const HUBSPOT_COOKIE = /(?:(?:^|.*;\s*)hubspotutk\s*=\s*([^;]*).*$)|^.*$/;

// will match a Shopify product ID from the shopify strings shopifyId or storefrontId
export const SHOPIFY_ID_REGEX = /(\d+)$/;
